import { useState, useEffect, useMemo } from "react";
import {t} from 'i18next';
import {
    Col, Container,
    Card, CardBody, CardHeader, CardTitle,
    Badge,
    Table,
    Nav, NavItem, NavLink, TabContent, TabPane,
    Button,
    Input,
    Label,
    Modal, ModalHeader, ModalBody,
} from "reactstrap";
import { CheckCircle2, Clock, /*Car, Users,*/ TrendingUp, Euro, /*Package, Wrench,*/ Calendar/*, FileText*/ } from "lucide-react";
// import { base44 } from "@/api/base44Client";
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { toast } from "sonner";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,/* PieChart, Pie, Cell, LineChart, Line,*/ Legend } from "recharts";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { useRecoilValue } from 'recoil'
import moment from "moment";

import env from '../../env/src_config';
import { axiosError } from "../../helpers/response";
import { isNull, number_format } from "../../izUtils";
// import { transformer } from "../../helpers/fields";
import { headersState } from "../../recoil/recoil";

// import SavedViews from "../components/analytics/SavedViews";
// import PredictiveAnalytics from "../components/analytics/PredictiveAnalytics";
// import ComparativeAnalysis from "../components/analytics/ComparativeAnalysis";
// import AnomalyDetection from "../components/analytics/AnomalyDetection";
import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb';

// const COLORS = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4'];

// const timePeriods = [
//   { value: 'all', label: 'Vse' },
//   { value: 'current_year', label: 'Tekoče leto' },
//   { value: '2020', label: '2020' },
//   { value: '2021', label: '2021' },
//   { value: '2022', label: '2022' },
//   { value: '2023', label: '2023' },
//   { value: '2024', label: '2024' },
//   { value: '2025', label: '2025' },
//   { value: '2026', label: '2026' },
//   { value: '2027', label: '2027' },
//   { value: '2028', label: '2028' },
//   { value: '2029', label: '2029' },
//   { value: '2030', label: '2030' },
//   { value: 'custom', label: 'Po meri' },
// ];

// const serviceTypes = ['Servis', 'Redni pregled', 'Dograditev', 'Delo na daljavo', 'Garancija'];
// const systems = ['Videonadzor', 'Požarni sistem', 'Vlomna zaščita', 'Kontrola pristopa', 'Domofonija'];
// const departments = ['IT oddelek', 'Servis', 'Projektno vodenje'];
// const technicians = ['Janez Novak', 'Marko Horvat', 'Peter Krajnc', 'Luka Vidmar', 'Matej Kovač'];

export default function Analytics() {
    const navigate = useNavigate();
    const headers = useRecoilValue(headersState);

    const [activeTab, setActiveTab] = useState("contracts");
    const [timePeriod, setTimePeriod] = useState("custom");

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    // const [selectedServiceType, setSelectedServiceType] = useState("all");
    // const [selectedTechnician, setSelectedTechnician] = useState("all");
    // const [selectedSystem, setSelectedSystem] = useState("all");
    // const [selectedDepartment, setSelectedDepartment] = useState("all");
    // const [isWarrantyDialogOpen, setIsWarrantyDialogOpen] = useState(false);
    // const [selectedWarrantySystem, setSelectedWarrantySystem] = useState('');


    // Sklenjene in prekinjene pogodbe
    const [stats, setStats] = useState(null);
    const [contractsViewMode, setContractsViewMode] = useState("months"); // months or years
    const [contractsModalOpen, setContractsModalOpen] = useState(false);

    const [selectedPeriodContracts, setSelectedPeriodContracts] = useState(null);
    const [statsPrices, setStatsPrices] = useState(null);
    const [revenueViewMode, setRevenueViewMode] = useState("months"); // months or years
    const [statsGroups, setStatsGroups] = useState([]);
    const [statsValue, setStatsValue] = useState([]);
    const lsFilterName = 'AKODA.statisticFilter';

    useEffect(() => {
        let lsFilter = JSON.parse(localStorage.getItem(lsFilterName));
        const startOfYear = moment().startOf('year').format('YYYY-MM-DD')
        const endOfYear = moment().endOf('year').format('YYYY-MM-DD')

        setDateFrom(startOfYear);
        setDateTo(endOfYear);

        if (isNull(lsFilter) || isNull(lsFilter.from) || isNull(lsFilter.to)) {
            lsFilter = {
                from: { value: startOfYear },
                to: { value: endOfYear }
            };
        } else {
            lsFilter.from.value = startOfYear;
            lsFilter.to.value = endOfYear;
        }


        getData(isNull(lsFilter) ? null : lsFilter, true);
        getPrices(isNull(lsFilter) ? null : lsFilter, true);
        getGroups(isNull(lsFilter) ? null : lsFilter, true);
        getValue(isNull(lsFilter) ? null : lsFilter, true);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getData = (passedFilters, save) => {
        // setLoading(true);
        let payload = { data: {}, save };

        if (!isNull(passedFilters)) {
            const keys = Object.keys(passedFilters);
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedFilters[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        axios.post(env.api + '/api/statistics/data', payload, {headers}).then(response => {
            // if (!isNull(response.data?.data)) {
            //     const transformedFilters = transformer(response.data.data)
            //     setFilters(transformedFilters);
            //     localStorage.setItem(lsFilterName, JSON.stringify(transformedFilters));
            //     if (save) checkFilters(transformedFilters);
            // }

            if (!isNull(response.data?.stats) && (
                (Array.isArray(response.data.stats) && response.data.stats.length > 0) ||
                (!Array.isArray(response.data.stats) && Object.keys(response.data.stats || {}).length > 0)
            )) {
                setStats(response.data?.stats);
            }

            // setLoading(false);
        }).catch(error => {
            axiosError(error, navigate);
            // setLoading(false);
        });
    }

    const getContracts = (period) => {
        let payload = {
            save: true,
            data: {}
        };

        if (contractsViewMode === 'years') {
            payload.data.from = moment(period + '-01-01').format('YYYY-MM-DD');
            payload.data.to = moment(period + '-12-31').format('YYYY-MM-DD');
        } else if (contractsViewMode === 'months') {
            payload.data.from = moment(period + '-01').format('YYYY-MM-DD');
            payload.data.to = moment(period + '-01').endOf('month').format('YYYY-MM-DD');
        }

        axios.post(env.api + '/api/statistics/contracts', payload, { headers }).then(response => {
            if (!isNull(response.data?.contracts)) {
                setSelectedPeriodContracts({
                    ...response.data?.contracts,
                    period: period
                });
            }
            setContractsModalOpen(true);
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const getPrices = (passedFilters, save) => {
        let payload = { data: {}, save };

        if (!isNull(passedFilters)) {
            const keys = Object.keys(passedFilters);
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedFilters[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        axios.post(env.api + '/api/statistics/prices', payload, {headers}).then(response => {
            if (!isNull(response.data?.prices) && (
                (Array.isArray(response.data.prices) && response.data.prices.length > 0) ||
                (!Array.isArray(response.data.prices) && Object.keys(response.data.prices || {}).length > 0)
            )) {
                setStatsPrices(response.data?.prices);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const getGroups = (passedFilters, save) => {
        let payload = { data: {}, save };

        if (!isNull(passedFilters)) {
            const keys = Object.keys(passedFilters);
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedFilters[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        axios.post(env.api + '/api/statistics/groups', payload, {headers}).then(response => {
            if (!isNull(response.data?.prices)) {
                setStatsGroups(response.data?.prices);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const getValue = (passedFilters, save) => {
        let payload = { data: {}, save };

        if (!isNull(passedFilters)) {
            const keys = Object.keys(passedFilters);
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedFilters[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        axios.post(env.api + '/api/statistics/value', payload, {headers}).then(response => {
            if (!isNull(response.data?.groups)) {
                setStatsValue(response.data?.groups);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    //   const queryClient = useQueryClient();

    //   const generateReportMutation = useMutation({
        // mutationFn: async (reportData) => {
        //   const user = await base44.auth.me();
        //   return base44.entities.Report.create({
        //     ...reportData,
        //     generated_by: user.email,
        //   });
        // },
        // onSuccess: () => {
        //   queryClient.invalidateQueries({ queryKey: ['reports'] });
        //   toast.success("Poročilo uspešno generirano");
        // },
    //   });

    // const handleGenerateReport = () => {
    //     const reportData = {
    //     title: `Analitika - ${timePeriod === 'current_year' ? 'Tekoče leto' : timePeriod}`,
    //     type: timePeriod === 'current_year' ? 'custom' : 'monthly',
    //     category: 'analytics',
    //     period_from: dateFrom || '2025-01-01',
    //     period_to: dateTo || '2025-12-31',
    //     data: {
    //         filters: currentFilters,
    //         stats: statsDummy,
    //         summary: `Poročilo za obdobje ${timePeriod}`,
    //     },
    //     is_automatic: false,
    //     };
    //     generateReportMutation.mutate(reportData);
    // };

    // const currentFilters = useMemo(() => ({
    //     timePeriod,
    //     dateFrom,
    //     dateTo,
    //     selectedServiceType,
    //     selectedTechnician,
    //     selectedSystem,
    //     selectedDepartment,
    // }), [timePeriod, dateFrom, dateTo, selectedServiceType, selectedTechnician, selectedSystem, selectedDepartment]);

    // const handleLoadView = (filters) => {
    //     setTimePeriod(filters.timePeriod || "current_year");
    //     setDateFrom(filters.dateFrom || "");
    //     setDateTo(filters.dateTo || "");
    //     setSelectedServiceType(filters.selectedServiceType || "all");
    //     setSelectedTechnician(filters.selectedTechnician || "all");
    //     setSelectedSystem(filters.selectedSystem || "all");
    //     setSelectedDepartment(filters.selectedDepartment || "all");
    // };

    // Mock podatki - kasneje povezati z entitetami
    // Podatki se prilagodijo glede na izbrano časovno obdobje
    // const statsDummy = useMemo(() => {
    //     const baseStats = {
    //         all: { completedTasks: 850, workHours: 6800, travelHours: 1700, technicians: 8 },
    //         current_year: { completedTasks: 156, workHours: 1248, travelHours: 312, technicians: 8 },
    //         '2020': { completedTasks: 98, workHours: 784, travelHours: 196, technicians: 6 },
    //         '2021': { completedTasks: 112, workHours: 896, travelHours: 224, technicians: 6 },
    //         '2022': { completedTasks: 128, workHours: 1024, travelHours: 256, technicians: 7 },
    //         '2023': { completedTasks: 142, workHours: 1136, travelHours: 284, technicians: 7 },
    //         '2024': { completedTasks: 145, workHours: 1160, travelHours: 290, technicians: 7 },
    //         '2025': { completedTasks: 156, workHours: 1248, travelHours: 312, technicians: 8 },
    //         '2026': { completedTasks: 165, workHours: 1320, travelHours: 330, technicians: 8 },
    //         '2027': { completedTasks: 172, workHours: 1376, travelHours: 344, technicians: 8 },
    //         '2028': { completedTasks: 180, workHours: 1440, travelHours: 360, technicians: 9 },
    //         '2029': { completedTasks: 188, workHours: 1504, travelHours: 376, technicians: 9 },
    //         '2030': { completedTasks: 195, workHours: 1560, travelHours: 390, technicians: 9 },
    //         custom: { completedTasks: 156, workHours: 1248, travelHours: 312, technicians: 8 },
    //     };
    //     return baseStats[timePeriod] || baseStats.current_year;
    // }, [timePeriod]);

    // const timeSeriesData = [
    //     { month: 'Jan', work: 95, travel: 24 },
    //     { month: 'Feb', work: 102, travel: 28 },
    //     { month: 'Mar', work: 118, travel: 30 },
    //     { month: 'Apr', work: 98, travel: 26 },
    //     { month: 'Maj', work: 125, travel: 32 },
    //     { month: 'Jun', work: 110, travel: 29 },
    //     { month: 'Jul', work: 105, travel: 27 },
    //     { month: 'Avg', work: 98, travel: 25 },
    //     { month: 'Sep', work: 115, travel: 31 },
    //     { month: 'Okt', work: 122, travel: 33 },
    //     { month: 'Nov', work: 130, travel: 35 },
    //     { month: 'Dec', work: 130, travel: 32 },
    // ];

    // const systemsData = [
    //     { name: 'Kontrola pristopa', tasks: 45, hours: 360, serviceValue: 28800, materialValue: 4500 },
    //     { name: 'Videonadzor', tasks: 38, hours: 304, serviceValue: 24320, materialValue: 3800 },
    //     { name: 'Požarni sistemi', tasks: 32, hours: 256, serviceValue: 20480, materialValue: 3200 },
    //     { name: 'Domofonija', tasks: 25, hours: 200, serviceValue: 16000, materialValue: 2500 },
    //     { name: 'Aspiracija', tasks: 16, hours: 128, serviceValue: 10240, materialValue: 1600 },
    // ];

    // const serviceTypesData = [
    //     { name: 'Vzdrževanje', tasks: 65, hours: 520, serviceValue: 41600, materialValue: 6500 },
    //     { name: 'Popravilo', tasks: 48, hours: 384, serviceValue: 30720, materialValue: 4800 },
    //     { name: 'Inštalacija', tasks: 28, hours: 224, serviceValue: 17920, materialValue: 2800 },
    //     { name: 'Pregled', tasks: 15, hours: 120, serviceValue: 9600, materialValue: 1500 },
    // ];

    // const materialStats = {
    //     total: 15420,
    //     average: 98.8,
    // };

    // Povprečno število nalogov glede na izbrane filtre
    // const avgTasksStats = useMemo(() => {
    //     const baseAvg = {
    //     day: 1.2,
    //     week: 8.4,
    //     month: 36,
    //     year: 432,
    //     };

    //     // Simulacija filtriranja
    //     let multiplier = 1;
    //     if (selectedServiceType !== "all") multiplier *= 0.3;
    //     if (selectedTechnician !== "all") multiplier *= 0.2;
    //     if (selectedSystem !== "all") multiplier *= 0.25;
    //     if (selectedDepartment !== "all") multiplier *= 0.4;

    //     return {
    //     day: (baseAvg.day * multiplier).toFixed(1),
    //     week: (baseAvg.week * multiplier).toFixed(1),
    //     month: (baseAvg.month * multiplier).toFixed(0),
    //     year: (baseAvg.year * multiplier).toFixed(0),
    //     };
    // }, [selectedServiceType, selectedTechnician, selectedSystem, selectedDepartment]);

//     // Povprečni zaslužek po tipu storitve
//     const avgRevenueByService = [
//         { type: 'Servis', avgRevenue: 285, tasks: 65 },
//         { type: 'Redni pregled', avgRevenue: 180, tasks: 48 },
//         { type: 'Dograditev', avgRevenue: 520, tasks: 28 },
//         { type: 'Delo na daljavo', avgRevenue: 95, tasks: 15 },
//         { type: 'Garancija', avgRevenue: 0, tasks: 12 },
//     ];

//   // Povprečni zaslužek glede na časovno obdobje
//     const avgRevenueStats = useMemo(() => {
//         const baseRevenue = {
//         day: 342,
//         week: 2394,
//         month: 10260,
//         year: 123120,
//         };

//         let multiplier = 1;
//         if (selectedServiceType !== "all") multiplier *= 0.35;
//         if (selectedTechnician !== "all") multiplier *= 0.22;
//         if (selectedSystem !== "all") multiplier *= 0.28;
//         if (selectedDepartment !== "all") multiplier *= 0.45;

//         return {
//         day: (baseRevenue.day * multiplier).toFixed(0),
//         week: (baseRevenue.week * multiplier).toFixed(0),
//         month: (baseRevenue.month * multiplier).toFixed(0),
//         year: (baseRevenue.year * multiplier).toFixed(0),
//         };
//     }, [selectedServiceType, selectedTechnician, selectedSystem, selectedDepartment]);

    // const technicianStats = [
    //     { name: 'Janez Novak', tasks: 32, workHours: 256, travelHours: 64, revenue: 4250 },
    //     { name: 'Marko Horvat', tasks: 28, workHours: 224, travelHours: 56, revenue: 3680 },
    //     { name: 'Peter Krajnc', tasks: 25, workHours: 200, travelHours: 50, revenue: 3320 },
    //     { name: 'Luka Vidmar', tasks: 22, workHours: 176, travelHours: 44, revenue: 2890 },
    //     { name: 'Matej Kovač', tasks: 19, workHours: 152, travelHours: 38, revenue: 2540 },
    //     { name: 'Rok Petek', tasks: 15, workHours: 120, travelHours: 30, revenue: 1980 },
    //     { name: 'Tomaž Zupan', tasks: 10, workHours: 80, travelHours: 20, revenue: 1350 },
    //     { name: 'David Novak', tasks: 5, workHours: 40, travelHours: 10, revenue: 850 },
    // ];

    // const regionStats = [
    //     { region: 'Ljubljana', tasks: 48, avgRevenue: 285, mileageCost: 1350, travelCost: 960 },
    //     { region: 'Maribor', tasks: 35, avgRevenue: 265, mileageCost: 980, travelCost: 700 },
    //     { region: 'Celje', tasks: 28, avgRevenue: 245, mileageCost: 820, travelCost: 560 },
    //     { region: 'Kranj', tasks: 22, avgRevenue: 270, mileageCost: 650, travelCost: 440 },
    //     { region: 'Koper', tasks: 15, avgRevenue: 290, mileageCost: 1120, travelCost: 600 },
    //     { region: 'Nova Gorica', tasks: 8, avgRevenue: 260, mileageCost: 580, travelCost: 320 },
    // ];

    // Statistika pogodb glede na časovno obdobje
    const contractStats = useMemo(() => {
        if (isNull(stats)) return {
            concludedThisYear: 0, concludedLastYear: 0, terminatedThisYear: 0, terminatedLastYear: 0,
            concludedThisYearValue: 0, concludedLastYearValue: 0, terminatedThisYearValue: 0, terminatedLastYearValue: 0
        };

        const baseStats = {
            concludedThisYear: stats.general.signed_contracts.count, concludedLastYear: 0, terminatedThisYear: stats.general.expired_contracts.count, terminatedLastYear: 0,
            concludedThisYearValue: stats.general.signed_contracts.price, concludedLastYearValue: 0, terminatedThisYearValue: stats.general.expired_contracts.price, terminatedLastYearValue: 0
        }

        return baseStats;
    }, [/*timePeriod,*/ stats]);

    // Podatki za graf sklenjenih in prekinjenih pogodb po mesecih in letih
    const contractsTimeSeriesData = useMemo(() => {
        if (isNull(stats)) return [];

        let contractGraph = [];
        if (contractsViewMode === 'years') {
            stats.contract_graph.labels.forEach((label, index) => {
                let year = label.split('-')[0];
                let existingYear = contractGraph.find(item => item.year === year);

                if (existingYear) {
                    existingYear.concluded += stats.contract_graph.signed.counts[index];
                    existingYear.terminated += stats.contract_graph.expired.counts[index];
                    existingYear.concludedValue += stats.contract_graph.signed.prices[index];
                    existingYear.terminatedValue += stats.contract_graph.expired.prices[index];
                } else {
                    contractGraph.push({
                        year: year,
                        concluded: stats.contract_graph.signed.counts[index],
                        terminated: stats.contract_graph.expired.counts[index],
                        concludedValue: stats.contract_graph.signed.prices[index],
                        terminatedValue: stats.contract_graph.expired.prices[index],
                    });
                }
            })
        } else if (contractsViewMode === 'months') {
            stats.contract_graph.labels.forEach((label, index) => {
                contractGraph.push({
                    month: label,
                    concluded: stats.contract_graph.signed.counts[index],
                    terminated: stats.contract_graph.expired.counts[index],
                    concludedValue: stats.contract_graph.signed.prices[index],
                    terminatedValue: stats.contract_graph.expired.prices[index],
                });
            });
        }

        return contractGraph;
    }, [/*timePeriod,*/ stats, contractsViewMode]);


    // // Mock podatki za garancijske naloge po sistemih
    // const warrantyTasksBySystem = {
    //     'Videonadzor': [
    //     { object: 'ABC Poslovna stavba', date: '15.11.2024', service: 1250, material: 850, workOrderId: 'WO-2024-1145' },
    //     { object: 'Poslovna cona Letališče', date: '28.09.2024', service: 1920, material: 1450, workOrderId: 'WO-2024-1089' },
    //     { object: 'Trgovina Center', date: '12.09.2024', service: 780, material: 520, workOrderId: 'WO-2024-1056' },
    //     ],
    //     'Kontrola pristopa': [
    //     { object: 'XYZ Trgovski center', date: '08.11.2024', service: 980, material: 620, workOrderId: 'WO-2024-1132' },
    //     { object: 'Poslovna zgradba Delta', date: '18.10.2024', service: 1150, material: 890, workOrderId: 'WO-2024-1098' },
    //     ],
    //     'Požarni sistemi': [
    //     { object: 'Hotel Central', date: '22.10.2024', service: 1680, material: 1240, workOrderId: 'WO-2024-1105' },
    //     { object: 'Bolnišnica Celje', date: '05.10.2024', service: 2100, material: 1650, workOrderId: 'WO-2024-1078' },
    //     ],
    //     'Domofonija': [
    //     { object: 'Stanovanjski kompleks Brdo', date: '05.10.2024', service: 850, material: 480, workOrderId: 'WO-2024-1076' },
    //     { object: 'Apartmaji Sonce', date: '20.09.2024', service: 680, material: 420, workOrderId: 'WO-2024-1045' },
    //     ],
    //     'Aspiracija': [
    //     { object: 'Tovarna Maribor', date: '14.10.2024', service: 2450, material: 1820, workOrderId: 'WO-2024-1091' },
    //     ],
    // };

    // Podatki za letni fiksni prihodek po mesecih
    const revenueTimeSeriesData = useMemo(() => {
        if (isNull(statsPrices)) return [];

        let priceGraph = [];
        if (revenueViewMode === 'years') {
            statsPrices.labels.forEach((label, index) => {
                let year = label.split('-')[0];
                let existingYear = priceGraph.find(item => item.year === year);

                if (existingYear) {
                    existingYear.monthlyFixed += statsPrices.lump_sum[index];
                    existingYear.perInspection += statsPrices.checks[index];
                } else {
                    priceGraph.push({
                        year: year,
                        monthlyFixed: statsPrices.lump_sum[index],
                        perInspection: statsPrices.checks[index],
                    });
                }
            })
        } else if (revenueViewMode === 'months') {
            statsPrices.labels.forEach((label, index) => {
                priceGraph.push({
                    month: label,
                    monthlyFixed: statsPrices.lump_sum[index],
                    perInspection: statsPrices.checks[index],
                });
            });
        }

        return priceGraph;
    }, [/*timePeriod,*/ statsPrices, revenueViewMode]);

    return (
        <>
            <Breadcrumbs parent="" title={t('breadcrumb.statistic')} />
            <Container fluid={true}>
                <div className="min-vh-100 analytics-page">
                    <div className="d-flex flex-column gap-3">
                        {/* Header */}
                        <div className="d-flex flex-column gap-4">
                            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
                                <div>
                                    {/* <h1 className="text-2xl fw-bold text-dark">Analitika</h1> */}
                                    <p className="text-sm text-muted">Pregled poslovanja in statistike servisnih nalogov</p>
                                </div>
                                <div className="d-flex gap-2">
                                    {/* <SavedViews currentFilters={currentFilters} onLoadView={handleLoadView} /> */}
                                    {/* <Button
                                        onClick={handleGenerateReport}
                                        color="success"
                                        size="sm"
                                    >
                                        <FileText className="me-2" />
                                        <span className="d-none d-sm-inline">Generiraj poročilo</span>
                                        <span className="d-sm-none">Poročilo</span>
                                    </Button> */}
                                </div>
                            </div>

                            {/* Časovni filter */}
                            <Card>
                                <CardBody className="p-3">
                                    {/* <div className="d-flex flex-wrap align-items-center mb-3 pb-3">
                                        {timePeriods.map((period) => {
                                            const isActive = timePeriod === period.value;
                                            return isActive ? (
                                                <Button
                                                    key={period.value}
                                                    color="primary"
                                                    size="sm"
                                                    onClick={() => setTimePeriod(period.value)}
                                                >
                                                    {period.label}
                                                </Button>
                                                ) : (
                                                <Button
                                                    key={period.value}
                                                    color="primary"
                                                    outline
                                                    size="sm"
                                                    onClick={() => setTimePeriod(period.value)}
                                                >
                                                    {period.label}
                                                </Button>
                                            );
                                        })}
                                    </div> */}

                                    {timePeriod === 'custom' && (
                                        <>
                                            <div className="row">
                                                <Col md="6">
                                                    <div className="my-2">
                                                        <Label className="d-flex align-items-center gap-2">
                                                            <Calendar style={{width: "1rem", height: "1rem"}} />
                                                            Od
                                                        </Label>
                                                        <Input
                                                            type="date"
                                                            value={dateFrom}
                                                            onChange={(e) => setDateFrom(e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <div className="my-2">
                                                        <Label className="d-flex align-items-center gap-2">
                                                        <Calendar style={{width: "1rem", height: "1rem"}} />
                                                        Do
                                                        </Label>
                                                        <Input
                                                        type="date"
                                                        value={dateTo}
                                                        onChange={(e) => setDateTo(e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                            </div>
                                            <div className="row">
                                                <div className="d-flex align-items-center justify-content-start mt-4">
                                                    <Button color="primary" onClick={() => {
                                                            let payload = {
                                                                from: { value: dateFrom },
                                                                to: { value: dateTo }
                                                            };

                                                        getData(payload, true);
                                                        getPrices(payload, true);
                                                        getGroups(payload, true);
                                                        getValue(payload, true);
                                                    }}>
                                                        Osveži podatke
                                                    </Button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </CardBody>
                            </Card>
                        </div>

                        {/* Tabs za kategorije */}
                        <Nav tabs className="mb-3">
                            <NavItem>
                                <NavLink
                                    className={activeTab === "work_orders" ? "active" : ""}
                                    onClick={() => setActiveTab("work_orders")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Statistika delovnih nalogov
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === "contracts" ? "active" : ""}
                                    onClick={() => setActiveTab("contracts")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Statistika pogodb
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>

                            <TabPane tabId="work_orders">
                                {/* Splošna statistika */}
                                {/* <div className="row gap-4">
                                    <Card className="hover:shadow-xl border-0">
                                        <CardBody className="p-4 sm:p-6">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className="small fw-medium text-success mb-1">Zaključene naloge</p>
                                                    <p className="text-2xl fw-bold text-green-900">{statsDummy.completedTasks}</p>
                                                    <p className="small text-success mt-1">✓ Vse opravljeno</p>
                                                </div>
                                                <div className="w-12">
                                                    <CheckCircle2 className="w-6 text-white" />
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    <Card className="hover:shadow-xl border-0">
                                        <CardBody className="p-4 sm:p-6">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className="small fw-medium text-primary mb-1">Opravljene ure</p>
                                                    <p className="text-2xl fw-bold text-blue-900">{statsDummy.workHours}h</p>
                                                    <p className="small text-primary mt-1">Delovni čas</p>
                                                </div>
                                                <div className="w-12">
                                                    <Clock className="w-6 text-white" />
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    <Card className="hover:shadow-xl border-0">
                                        <CardBody className="p-4 sm:p-6">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className="small fw-medium text-warning mb-1">Potovalne ure</p>
                                                    <p className="text-2xl fw-bold text-orange-900">{statsDummy.travelHours}h</p>
                                                    <p className="small text-warning mt-1">Vožnja na teren</p>
                                                </div>
                                                <div className="w-12">
                                                    <Car className="w-6 text-white" />
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    <Card className="hover:shadow-xl border-0">
                                        <CardBody className="p-4 sm:p-6">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className="small fw-medium text-primary mb-1">Število tehnikov</p>
                                                    <p className="text-2xl fw-bold text-purple-900">{statsDummy.technicians}</p>
                                                    <p className="small text-primary mt-1">Aktivni zaposleni</p>
                                                </div>
                                                <div className="w-12">
                                                    <Users className="w-6 text-white" />
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div> */}

                {/* Časovni graf */}
                {/* <Card className="border-0 shadow-lg">
                <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                    <div className="w-8 h-8">
                        <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                    </div>
                    Ure dela in potovanja
                    <Badge className="ml-auto bg-blue-100 text-primary">Mesečni pregled</Badge>
                    </CardTitle>
                </CardHeader>
                <CardBody className="p-3 sm:p-6">
                    <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={timeSeriesData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis
                        dataKey="month"
                        stroke="#64748b"
                        style={{ fontSize: '12px' }}
                        />
                        <YAxis
                        stroke="#64748b"
                        style={{ fontSize: '12px' }}
                        />
                        <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }}
                        />
                        <Legend
                        wrapperStyle={{ paddingTop: '20px' }}
                        iconType="circle"
                        />
                        <Line
                        type="monotone"
                        dataKey="work"
                        stroke="url(#colorWork)"
                        name="Ure dela"
                        strokeWidth={3}
                        dot={{ fill: '#3b82f6', r: 4 }}
                        activeDot={{ r: 6 }}
                        />
                        <Line
                        type="monotone"
                        dataKey="travel"
                        stroke="url(#colorTravel)"
                        name="Potovalne ure"
                        strokeWidth={3}
                        dot={{ fill: '#f59e0b', r: 4 }}
                        activeDot={{ r: 6 }}
                        />
                        <defs>
                        <linearGradient id="colorWork" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.3}/>
                        </linearGradient>
                        <linearGradient id="colorTravel" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#f59e0b" stopOpacity={0.3}/>
                        </linearGradient>
                        </defs>
                    </LineChart>
                    </ResponsiveContainer>
                </CardBody>
                </Card> */}

                {/* Tortni prikazi */}
                {/* <div className="grid lg:grid-cols-2 gap-6">
                <Card className="border-0 shadow-lg">
                    <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                        <div className="w-8 h-8">
                        <Wrench className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                        </div>
                        Naloge po sistemih
                        <Badge className="ml-auto bg-purple-100 text-purple-700">Porazdelitev</Badge>
                    </CardTitle>
                    </CardHeader>
                    <CardBody className="p-3 sm:p-6">
                    <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                        <Pie
                            data={systemsData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="tasks"
                        >
                            {systemsData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            content={({ active, payload }) => {
                            if (active && payload && payload.length) {
                                const data = payload[0].payload;
                                return (
                                <div className="bg-white p-3 border border-slate-200 rounded shadow-lg">
                                    <p className="font-semibold mb-1">{data.name}</p>
                                    <p className="text-sm">Naloge: {data.tasks}</p>
                                    <p className="text-sm">Ure: {data.hours}h</p>
                                    <p className="text-sm text-success font-semibold">Storitve: {data.serviceValue.toLocaleString('sl-SI')} €</p>
                                    <p className="text-sm text-primary font-semibold">Material: {data.materialValue.toLocaleString('sl-SI')} €</p>
                                    <p className="text-sm fw-bold border-top pt-1 mt-1">Skupaj: {(data.serviceValue + data.materialValue).toLocaleString('sl-SI')} €</p>
                                </div>
                                );
                            }
                            return null;
                            }}
                        />
                        </PieChart>
                    </ResponsiveContainer>
                    <div className="mt-4 gap-2 flex-column">
                        {systemsData.map((item, index) => (
                        <div key={index} className="d-flex justify-content-between align-items-center text-sm">
                            <div className="d-flex align-items-center gap-2">
                            <div className="w-3 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }} />
                            <span>{item.name}</span>
                            </div>
                            <div className="d-flex gap-4 text-muted">
                            <span>{item.tasks} nalog</span>
                            <span>{item.hours}h</span>
                            <span className="font-semibold text-success">{(item.serviceValue + item.materialValue).toLocaleString('sl-SI')} €</span>
                            </div>
                        </div>
                        ))}
                    </div>
                    </CardBody>
                </Card>

                <Card className="border-0 shadow-lg">
                    <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                        <div className="w-8 h-8">
                        <Package className="w-5 h-5 text-white" />
                        </div>
                        Tipi storitev
                        <Badge className="ml-auto bg-green-100 text-success">Razdelitev</Badge>
                    </CardTitle>
                    </CardHeader>
                    <CardBody className="p-3 sm:p-6">
                    <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                        <Pie
                            data={serviceTypesData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="tasks"
                        >
                            {serviceTypesData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            content={({ active, payload }) => {
                            if (active && payload && payload.length) {
                                const data = payload[0].payload;
                                return (
                                <div className="bg-white p-3 border border-slate-200 rounded shadow-lg">
                                    <p className="font-semibold mb-1">{data.name}</p>
                                    <p className="text-sm">Naloge: {data.tasks}</p>
                                    <p className="text-sm">Ure: {data.hours}h</p>
                                    <p className="text-sm text-success font-semibold">Storitve: {data.serviceValue.toLocaleString('sl-SI')} €</p>
                                    <p className="text-sm text-primary font-semibold">Material: {data.materialValue.toLocaleString('sl-SI')} €</p>
                                    <p className="text-sm fw-bold border-top pt-1 mt-1">Skupaj: {(data.serviceValue + data.materialValue).toLocaleString('sl-SI')} €</p>
                                </div>
                                );
                            }
                            return null;
                            }}
                        />
                        </PieChart>
                    </ResponsiveContainer>
                    <div className="my-2 mt-4">
                        {serviceTypesData.map((item, index) => (
                        <div key={index} className="p-3">
                            <div className="d-flex justify-content-between items-center">
                            <div className="d-flex align-items-center gap-3 flex-1">
                                <div className="w-10 h-10 rounded-3 d-flex align-items-center justify-content-center shadow-sm" style={{ backgroundColor: COLORS[index % COLORS.length] }}>
                                <Package className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                <p className="font-semibold small text-dark">{item.name}</p>
                                <div className="d-flex gap-3 mt-1 small text-muted">
                                    <span className="d-flex align-items-center gap-1">
                                    <CheckCircle2 className="w-3 h-3" />
                                    {item.tasks} nalog
                                    </span>
                                    <span className="d-flex align-items-center gap-1">
                                    <Clock className="w-3 h-3" />
                                    {item.hours}h
                                    </span>
                                </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-lg fw-bold text-success">{(item.serviceValue + item.materialValue).toLocaleString('sl-SI')} €</p>
                                <p className="small text-muted">skupna vrednost</p>
                            </div>
                            </div>
                        </div>
                        ))}
                    </div>
                    </CardBody>
                </Card>
                </div> */}

                {/* Material statistika */}
                {/* <Card className="border-0 shadow-lg">
                <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                    <div className="w-8 h-8">
                        <Package className="w-5 h-5 text-white" />
                    </div>
                    Zaračunan material
                    <Badge className="ml-auto bg-amber-100 text-amber-700">Skupna vrednost</Badge>
                    </CardTitle>
                </CardHeader>
                <CardBody className="p-6">
                    <div className="grid gap-6">
                    <div className="p-4 bg-white/60 rounded-3 border border-amber-200">
                        <p className="text-sm fw-semibold text-amber-800 mb-2 d-flex align-items-center gap-2">
                        <Euro style={{width: "1rem", height: "1rem"}} />
                        Skupna vrednost
                        </p>
                        <p className="text-4xl fw-bold text-amber-900">{materialStats.total.toLocaleString('sl-SI')} €</p>
                        <div className="mt-2 bg-warning bg-opacity-25 rounded-circle overflow-hidden">
                        <div className="h-full"></div>
                        </div>
                    </div>
                    <div className="p-4 bg-white/60 rounded-3 border border-orange-200">
                        <p className="text-sm fw-semibold text-orange-800 mb-2 d-flex align-items-center gap-2">
                        <Package style={{width: "1rem", height: "1rem"}} />
                        Povprečje na nalogo
                        </p>
                        <p className="text-4xl fw-bold text-orange-900">{materialStats.average.toFixed(2)} €</p>
                        <p className="small text-warning mt-2">Povprečna poraba materiala</p>
                    </div>
                    </div>
                </CardBody>
                </Card> */}

                {/* Statistika tehnikov */}
                {/* <Card className="border-0 shadow-lg">
                <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                    <div className="w-8 h-8">
                        <Users className="w-5 h-5 text-white" />
                    </div>
                    Statistika tehnikov
                    <Badge className="ml-auto">Performance pregled</Badge>
                    </CardTitle>
                </CardHeader>
                <CardBody> */}
                    {/* Desktop Table */}
                    {/* <div className="d-none d-md-block overflow-auto">
                    <Table>
                        <thead>
                        <tr>
                            <th>Tehnik</th>
                            <th className="text-center">Naloge</th>
                            <th className="text-center">Ure dela</th>
                            <th className="text-center">Vožnja</th>
                            <th className="text-right">Vrednost storitev</th>
                        </tr>
                        </thead>
                        <tbody>
                        {technicianStats.map((tech, index) => (
                            <tr key={index}>
                            <td className="font-medium">{tech.name}</td>
                            <td className="text-center">
                                <Badge color="secondary">{tech.tasks}</Badge>
                            </td>
                            <td className="text-center">{tech.workHours}h</td>
                            <td className="text-center">{tech.travelHours}h</td>
                            <td className="text-right font-weight-bold">{tech.revenue.toLocaleString('sl-SI')} €</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    </div> */}

                    {/* Mobile Cards */}
                    {/* <div className="md:hidden gap-3 flex-column">
                    {technicianStats.map((tech, index) => (
                        <Card key={index} className="p-4 touch-manipulation active:scale-[0.98] transition-transform">
                        <div className="d-flex justify-content-between align-items-start mb-3 pb-3 border-b">
                            <h4 className="font-semibold text-base">{tech.name}</h4>
                            <Badge color="secondary">{tech.tasks} nalog</Badge>
                        </div>
                        <div className="my-2 text-sm">
                            <div className="d-flex justify-content-between">
                            <span className="text-slate-600">Ure dela:</span>
                            <span className="font-semibold">{tech.workHours}h</span>
                            </div>
                            <div className="d-flex justify-content-between">
                            <span className="text-slate-600">Potovalne ure:</span>
                            <span className="font-semibold">{tech.travelHours}h</span>
                            </div>
                            <div className="d-flex justify-content-between pt-2 border-t">
                            <span className="text-slate-600">Vrednost storitev:</span>
                            <span className="font-bold text-green-600">{tech.revenue.toLocaleString('sl-SI')} €</span>
                            </div>
                        </div>
                        </Card>
                    ))}
                    </div>
                </CardBody>
                </Card> */}

                {/* Napredni filtri */}
                {/* <Card>
                <CardHeader>
                    <div className="d-flex align-items-center justify-content-between">
                    <CardTitle className="sm:text-lg">Napredni filtri</CardTitle>
                    {(selectedServiceType !== "all" || selectedTechnician !== "all" || selectedSystem !== "all" || selectedDepartment !== "all") && (
                        <Button
                        color="link"
                        size="sm"
                        onClick={() => {
                            setSelectedServiceType("all");
                            setSelectedTechnician("all");
                            setSelectedSystem("all");
                            setSelectedDepartment("all");
                        }}
                        className="text-red-600 hover:text-red-700"
                        >
                        Počisti vse filtre
                        </Button>
                    )}
                    </div>
                </CardHeader>
                <CardBody className="p-3 gap-3 flex-column"> */}
                    {/* Prikaz aktivnih filtrov */}
                    {/* {(selectedServiceType !== "all" || selectedTechnician !== "all" || selectedSystem !== "all" || selectedDepartment !== "all") && (
                    <div className="p-3 bg-blue-50 rounded border border-blue-200">
                        <p className="small fw-semibold text-primary mb-2">Aktivni filtri:</p>
                        <div className="d-flex flex-wrap gap-2">
                        {selectedServiceType !== "all" && (
                            <Badge className="bg-blue-600 hover:bg-blue-700" onClick={() => setSelectedServiceType("all")}>
                            Storitev: {selectedServiceType} ×
                            </Badge>
                        )}
                        {selectedTechnician !== "all" && (
                            <Badge className="bg-purple-600 hover:bg-purple-700" onClick={() => setSelectedTechnician("all")}>
                            Tehnik: {selectedTechnician} ×
                            </Badge>
                        )}
                        {selectedSystem !== "all" && (
                            <Badge className="bg-success" onClick={() => setSelectedSystem("all")}>
                            Sistem: {selectedSystem} ×
                            </Badge>
                        )}
                        {selectedDepartment !== "all" && (
                            <Badge className="bg-orange-600 hover:bg-orange-700" onClick={() => setSelectedDepartment("all")}>
                            Oddelek: {selectedDepartment} ×
                            </Badge>
                        )}
                        </div>
                    </div>
                    )}

                    <div className="grid sm:grid-cols-2 gap-3 sm:gap-4">
                    <div className="my-2">
                        <Label className="small d-flex align-items-center justify-content-between">
                        Tip storitve
                        {selectedServiceType !== "all" && (
                            <Badge color="secondary" className="text-xs">Aktiven</Badge>
                        )}
                        </Label>
                        <Input type="select" value={selectedServiceType} onChange={(e) => setSelectedServiceType(e.target.value)} className="text-sm">
                        <option value="all">Vse storitve</option>
                        {serviceTypes.map((type) => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                        </Input>
                    </div>

                    <div className="my-2">
                        <Label className="small d-flex align-items-center justify-content-between">
                        Tehnik
                        {selectedTechnician !== "all" && (
                            <Badge color="secondary" className="text-xs">Aktiven</Badge>
                        )}
                        </Label>
                        <Input type="select" value={selectedTechnician} onChange={(e) => setSelectedTechnician(e.target.value)} className="text-sm">
                        <option value="all">Vsi tehniki</option>
                        {technicians.map((tech) => (
                            <option key={tech} value={tech}>{tech}</option>
                        ))}
                        </Input>
                    </div>

                    <div className="my-2">
                        <Label className="small d-flex align-items-center justify-content-between">
                        Sistem
                        {selectedSystem !== "all" && (
                            <Badge color="secondary" className="text-xs">Aktiven</Badge>
                        )}
                        </Label>
                        <Input type="select" value={selectedSystem} onChange={(e) => setSelectedSystem(e.target.value)} className="text-sm">
                        <option value="all">Vsi sistemi</option>
                        {systems.map((sys) => (
                            <option key={sys} value={sys}>{sys}</option>
                        ))}
                        </Input>
                    </div>

                    <div className="my-2">
                        <Label className="small d-flex align-items-center justify-content-between">
                        Oddelek
                        {selectedDepartment !== "all" && (
                            <Badge color="secondary" className="text-xs">Aktiven</Badge>
                        )}
                        </Label>
                        <Input type="select" value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)} className="text-sm">
                        <option value="all">Vsi oddelki</option>
                        {departments.map((dept) => (
                            <option key={dept} value={dept}>{dept}</option>
                        ))}
                        </Input>
                    </div>
                    </div>

                    <div className="pt-2 border-top">
                    <p className="small text-muted mb-2">Hitri filtri:</p>
                    <div className="d-flex flex-wrap gap-2">
                        <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={() => {
                            setSelectedServiceType("Garancija");
                            setSelectedSystem("all");
                            setSelectedTechnician("all");
                            setSelectedDepartment("all");
                        }}

                        >
                        Samo garancija
                        </Button>
                        <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={() => {
                            setSelectedServiceType("Servis");
                            setSelectedSystem("all");
                            setSelectedTechnician("all");
                            setSelectedDepartment("all");
                        }}

                        >
                        Samo servis
                        </Button>
                        <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={() => {
                            setSelectedServiceType("all");
                            setSelectedSystem("Videonadzor");
                            setSelectedTechnician("all");
                            setSelectedDepartment("all");
                        }}

                        >
                        Videonadzor
                        </Button>
                        <Button
                        size="sm"
                        outline
                        color="primary"
                        onClick={() => {
                            setSelectedServiceType("all");
                            setSelectedSystem("all");
                            setSelectedTechnician("Janez Novak");
                            setSelectedDepartment("all");
                        }}

                        >
                        Top tehnik
                        </Button>
                    </div>
                    </div>
                </CardBody>
                </Card> */}

                {/* Povprečna statistika */}
                {/* <Card className="border-0 shadow-lg">
                <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                    <div className="w-8 h-8">
                        <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                    </div>
                    Povprečna statistika
                    <Badge className="ml-auto">KPI</Badge>
                    </CardTitle>
                </CardHeader>
                <CardBody className="p-3 sm:p-6">
                    <div className="space-y-6">
                    <div>
                        <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="w-6 bg-blue-500 rounded d-flex align-items-center justify-center">
                            <CheckCircle2 className="w-4 h-4 text-white" />
                        </div>
                        <h3 className="text-sm fw-bold text-slate-700 uppercase tracking-wide">Število nalogov</h3>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        <div className="p-4">
                            <p className="small fw-semibold text-primary mb-2">📅 NA DAN</p>
                            <p className="text-2xl fw-bold text-blue-900">{avgTasksStats.day}</p>
                            <div className="mt-2 h-1 bg-blue-200 rounded-full">
                            <div className="h-full" style={{width: '60%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-primary mb-2">📅 NA TEDEN</p>
                            <p className="text-2xl fw-bold text-purple-900">{avgTasksStats.week}</p>
                            <div className="mt-2 h-1 bg-purple-200 rounded-full">
                            <div className="h-full" style={{width: '75%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-primary mb-2">📅 NA MESEC</p>
                            <p className="text-2xl fw-bold text-primary">{avgTasksStats.month}</p>
                            <div className="mt-2 h-1 bg-indigo-200 rounded-full">
                            <div className="h-full" style={{width: '85%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-cyan-700 mb-2">📅 NA LETO</p>
                            <p className="text-2xl fw-bold text-cyan-900">{avgTasksStats.year}</p>
                            <div className="mt-2 h-1 bg-cyan-200 rounded-full">
                            <div className="h-full" style={{width: '100%'}}></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="pt-4 border-t-2 border-dashed">
                        <div className="d-flex align-items-center gap-2 mb-4">
                        <div className="w-6 bg-green-500 rounded d-flex align-items-center justify-center">
                            <Euro className="w-4 h-4 text-white" />
                        </div>
                        <h3 className="text-sm fw-bold text-slate-700 uppercase tracking-wide">Zaslužek (prihodki)</h3>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        <div className="p-4">
                            <p className="small fw-semibold text-success mb-2">💰 NA DAN</p>
                            <p className="text-2xl fw-bold text-green-900">{avgRevenueStats.day} €</p>
                            <div className="mt-2 h-1 bg-green-200 rounded-full">
                            <div className="h-full" style={{width: '50%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-emerald-700 mb-2">💰 NA TEDEN</p>
                            <p className="text-2xl fw-bold text-emerald-900">{avgRevenueStats.week} €</p>
                            <div className="mt-2 h-1 bg-emerald-200 rounded-full">
                            <div className="h-full" style={{width: '70%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-teal-700 mb-2">💰 NA MESEC</p>
                            <p className="text-2xl fw-bold text-teal-900">{avgRevenueStats.month} €</p>
                            <div className="mt-2 h-1 bg-teal-200 rounded-full">
                            <div className="h-full" style={{width: '90%'}}></div>
                            </div>
                        </div>
                        <div className="p-4">
                            <p className="small fw-semibold text-lime-700 mb-2">💰 NA LETO</p>
                            <p className="text-2xl fw-bold text-lime-900">{avgRevenueStats.year} €</p>
                            <div className="mt-2 h-1 bg-lime-200 rounded-full">
                            <div className="h-full" style={{width: '100%'}}></div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </CardBody>
                </Card> */}

                {/* Prediktivna analitika */}
                {/* <PredictiveAnalytics
                historicalData={timeSeriesData.map(d => ({ period: d.month, value: (d.work + d.travel) * 80 }))}
                metric="revenue"
                /> */}

                {/* Primerjalna analiza */}
                {/* <ComparativeAnalysis /> */}

                {/* Detekcija anomalij */}
                {/* <AnomalyDetection
                data={timeSeriesData.map(d => ({ period: d.month, value: (d.work + d.travel) * 80 }))}
                metric="revenue"
                /> */}

                {/* Garancijski nalogi */}
                {/* <Card className="border-0 shadow-lg">
                <CardHeader className="border-b">
                    <CardTitle className="d-flex align-items-center gap-2">
                    <div className="w-8 h-8">
                        <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                    </div>
                    Garancijski nalogi
                    <Badge className="ml-auto bg-red-100 text-danger">Brez stroškov za stranko</Badge>
                    </CardTitle>
                </CardHeader>
                <CardBody className="p-3 sm:p-6">
                    <div className="space-y-4"> */}
                    {/* Statistika */}
                    {/* <div className="grid md:grid-cols-3 gap-3 sm:gap-4">
                        <div className="p-4">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="small fw-bold text-primary uppercase">Posegi</p>
                            <div className="w-8 h-8 bg-blue-500 rounded d-flex align-items-center justify-center">
                            <CheckCircle2 className="w-5 h-5 text-white" />
                            </div>
                        </div>
                        <p className="text-4xl fw-bold text-blue-900">48</p>
                        <p className="small text-primary mt-1">Opravljenih garancij</p>
                        </div>
                        <div className="p-4">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="small fw-bold text-warning uppercase">Storitve</p>
                            <div className="w-8 h-8 bg-warning rounded d-flex align-items-center justify-center">
                            <Wrench className="w-5 h-5 text-white" />
                            </div>
                        </div>
                        <p className="text-4xl fw-bold text-orange-900">28,640 €</p>
                        <p className="small text-warning mt-1">Stroški dela</p>
                        </div>
                        <div className="p-4">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="small fw-bold text-danger uppercase">Material</p>
                            <div className="w-8 h-8 bg-red-500 rounded d-flex align-items-center justify-center">
                            <Package className="w-5 h-5 text-white" />
                            </div>
                        </div>
                        <p className="text-4xl fw-bold text-red-900">18,240 €</p>
                        <p className="small text-danger mt-1">Stroški materiala</p>
                        </div>
                    </div> */}

                    {/* Graf razdelitve */}
                    {/* <div className="grid lg:grid-cols-2 gap-4 sm:gap-6">
                        <div>
                        <h3 className="small fw-semibold text-slate-700 mb-2 sm:mb-3">Razdelitev stroškov</h3>
                        <ResponsiveContainer width="100%" height={200}>
                            <PieChart>
                            <Pie
                                data={[
                                { name: 'Storitve', value: 28640 },
                                { name: 'Material', value: 18240 },
                                ]}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                <Cell fill="#f97316" />
                                <Cell fill="#ef4444" />
                            </Pie>
                            <Tooltip formatter={(value) => `${value.toLocaleString('sl-SI')} €`} />
                            </PieChart>
                        </ResponsiveContainer>
                        </div>

                        <div>
                        <h3 className="small fw-semibold text-slate-700 mb-2 sm:mb-3">Razdelitev po sistemih</h3>
                        <ResponsiveContainer width="100%" height={200}>
                            <BarChart
                            data={[
                                { system: 'Videonadzor', count: 18 },
                                { system: 'Kontrola pristopa', count: 12 },
                                { system: 'Požarni sistemi', count: 9 },
                                { system: 'Domofonija', count: 6 },
                                { system: 'Aspiracija', count: 3 },
                            ]}
                            onClick={(data) => {
                                if (data && data.activeLabel) {
                                setSelectedWarrantySystem(data.activeLabel);
                                setIsWarrantyDialogOpen(true);
                                }
                            }}
                            >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="system" angle={-15} textAnchor="end" height={80} />
                            <YAxis />
                            <Tooltip
                                content={({ active, payload }) => {
                                if (active && payload && payload.length) {
                                    return (
                                    <div className="bg-white p-3 border border-slate-200 rounded shadow-lg">
                                        <p className="font-semibold">{payload[0].payload.system}</p>
                                        <p className="text-sm">Število: {payload[0].value}</p>
                                        <p className="small text-muted mt-1">Klikni za podrobnosti</p>
                                    </div>
                                    );
                                }
                                return null;
                                }}
                            />
                            <Bar dataKey="count" fill="#3b82f6" name="Število posegov" cursor="pointer" />
                            </BarChart>
                        </ResponsiveContainer>
                        </div>
                    </div> */}

                    {/* Tabela z objekti */}
                    {/* <div>
                        <h3 className="text-sm fw-semibold text-slate-700 mb-3">Seznam garancijskih posegov po objektih</h3>
                        <div className="overflow-x-auto">
                        <Table>
                            <thead>
                            <tr>
                                <th>Objekt</th>
                                <th>Sistem</th>
                                <th>Datum</th>
                                <th className="text-right">Storitve</th>
                                <th className="text-right">Material</th>
                                <th className="text-right">Skupaj</th>
                                <th className="text-center">Arhiv</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="font-medium">ABC Poslovna stavba</td>
                                <td><Badge className="bg-purple-100 text-purple-700">Videonadzor</Badge></td>
                                <td>15.11.2024</td>
                                <td className="text-right text-warning">1,250 €</td>
                                <td className="text-right text-danger">850 €</td>
                                <td className="text-right font-weight-bold">2,100 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-medium">XYZ Trgovski center</td>
                                <td><Badge className="bg-blue-100 text-primary">Kontrola pristopa</Badge></td>
                                <td>08.11.2024</td>
                                <td className="text-right text-warning">980 €</td>
                                <td className="text-right text-danger">620 €</td>
                                <td className="text-right font-weight-bold">1,600 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-medium">Hotel Central</td>
                                <td><Badge className="bg-red-100 text-danger">Požarni sistemi</Badge></td>
                                <td>22.10.2024</td>
                                <td className="text-right text-warning">1,680 €</td>
                                <td className="text-right text-danger">1,240 €</td>
                                <td className="text-right font-weight-bold">2,920 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-medium">Tovarna Maribor</td>
                                <td><Badge className="bg-cyan-100 text-cyan-700">Aspiracija</Badge></td>
                                <td>14.10.2024</td>
                                <td className="text-right text-warning">2,450 €</td>
                                <td className="text-right text-danger">1,820 €</td>
                                <td className="text-right font-weight-bold">4,270 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-medium">Stanovanjski kompleks Brdo</td>
                                <td><Badge className="bg-green-100 text-success">Domofonija</Badge></td>
                                <td>05.10.2024</td>
                                <td className="text-right text-warning">850 €</td>
                                <td className="text-right text-danger">480 €</td>
                                <td className="text-right font-weight-bold">1,330 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-medium">Poslovna cona Letališče</td>
                                <td><Badge className="bg-purple-100 text-purple-700">Videonadzor</Badge></td>
                                <td>28.09.2024</td>
                                <td className="text-right text-warning">1,920 €</td>
                                <td className="text-right text-danger">1,450 €</td>
                                <td className="text-right font-weight-bold">3,370 €</td>
                                <td className="text-center">
                                <Button color="link" size="sm" >
                                    Odpri
                                </Button>
                                </td>
                            </tr>
                            <tr className="font-weight-bold">
                                <td colSpan={3}>Skupaj prikazano:</td>
                                <td className="text-right text-warning">9,130 €</td>
                                <td className="text-right text-danger">6,460 €</td>
                                <td className="text-right">15,590 €</td>
                                <td></td>
                            </tr>
                            </tbody>
                        </Table>
                        </div>
                    </div> */}

                    {/* Mobile Cards - Garancijski posegi */}
                    {/* <div className="md:hidden">
                        <h3 className="small fw-semibold text-slate-700 mb-3">Garancijski posegi po objektih</h3>
                        <div className="my-2">
                        <Card className="p-3 touch-manipulation">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                            <h4 className="font-medium text-sm">ABC Poslovna stavba</h4>
                            <Badge className="bg-purple-100 text-primary text-xs">Videonadzor</Badge>
                            </div>
                            <div className="space-y-1 text-xs">
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Datum:</span><span>15.11.2024</span></div>
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Storitve:</span><span className="text-orange-700">1,250 €</span></div>
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Material:</span><span className="text-red-700">850 €</span></div>
                            <div className="d-flex justify-content-between pt-1 border-t"><span className="font-semibold">Skupaj:</span><span className="font-bold">2,100 €</span></div>
                            </div>
                        </Card>
                        <Card className="p-3 touch-manipulation">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                            <h4 className="font-medium text-sm">XYZ Trgovski center</h4>
                            <Badge className="bg-blue-100 text-primary text-xs">Kontrola pristopa</Badge>
                            </div>
                            <div className="space-y-1 text-xs">
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Datum:</span><span>08.11.2024</span></div>
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Storitve:</span><span className="text-orange-700">980 €</span></div>
                            <div className="d-flex justify-content-between"><span className="text-slate-600">Material:</span><span className="text-red-700">620 €</span></div>
                            <div className="d-flex justify-content-between pt-1 border-t"><span className="font-semibold">Skupaj:</span><span className="font-bold">1,600 €</span></div>
                            </div>
                        </Card>
                        </div>
                    </div>
                    </div>
                </CardBody>
                </Card> */}
                            </TabPane>

                            <TabPane tabId="contracts">
                                {/* Število pogodb - osnovni pregled */}
                                <div className="row">
                                    <Col sm="12" md="6">
                                        <Card className="analytics-card-signed">
                                            <CardBody className="p-3">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <p className="analytics-card-title">SKLENJENE LETOS</p>
                                                        <p className="analytics-card-count">{contractStats.concludedThisYear}</p>
                                                        <div className="d-flex align-items-baseline gap-1">
                                                            <Euro color="#16a34a" size="12px" />
                                                            <p className="analytics-card-price">
                                                                {number_format(contractStats.concludedThisYearValue, 2, ',', '.')}
                                                            </p>
                                                            <span className="analytics-card-year">/leto</span>
                                                        </div>
                                                    </div>
                                                    <div className="card-signed-bg">
                                                        <CheckCircle2 size="24px" color="#ffffff"/>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col sm="12" md="6">
                                        <Card className="analytics-card-expired">
                                            <CardBody className="p-3">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <p className="analytics-card-title">PREKINJENE LETOS</p>
                                                        <p className="analytics-card-count">{contractStats.terminatedThisYear}</p>
                                                        <div className="d-flex align-items-baseline gap-1">
                                                            <Euro color="#dc2626" size="12px" />
                                                            <p className="analytics-card-price">
                                                                {number_format(contractStats.terminatedThisYearValue, 2, ',', '.')}
                                                            </p>
                                                            <span className="analytics-card-year">/leto</span>
                                                        </div>
                                                    </div>
                                                    <div className="card-expired-bg">
                                                        <Clock size="24px" color="#ffffff" />
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </div>

                                {/* Graf sklenjenih in prekinjenih pogodb */}
                                <Card className="shadow-lg">
                                    <CardHeader className={"contracts-header p-4"}>
                                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
                                            <CardTitle className="d-flex align-items-center gap-2 mb-0">
                                                <div className="contracts-icon-wrapper">
                                                    <TrendingUp size={20} color="#fff" />
                                                </div>
                                                Sklenjene in prekinjene pogodbe
                                                <Badge className="contracts-badge">Letni trend</Badge>
                                            </CardTitle>
                                            <div className="d-flex gap-2">
                                                {contractsViewMode === "months" ? (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        onClick={() => setContractsViewMode("months")}
                                                    >
                                                        Po mesecih
                                                    </Button>
                                                    ) : (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        outline
                                                        onClick={() => setContractsViewMode("months")}
                                                    >
                                                        Po mesecih
                                                    </Button>
                                                )}
                                                {contractsViewMode === "years" ? (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        onClick={() => setContractsViewMode("years")}
                                                    >
                                                        Po letih
                                                    </Button>
                                                    ) : (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        outline
                                                        onClick={() => setContractsViewMode("years")}
                                                    >
                                                        Po letih
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody className={"p-0"}>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart
                                                data={contractsTimeSeriesData}
                                                onClick={(data) => getContracts(data?.activeLabel)}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey={contractsViewMode === "months" ? "month" : "year"} />
                                                <YAxis />
                                                <Tooltip
                                                    content={({ active, payload, label }) => {
                                                        if (active && payload && payload.length) {
                                                            return (
                                                                <div className="bg-white p-3 border-2 border-slate-200 rounded-3 shadow-2xl">
                                                                    <p className="font-bold fs-5 mb-3 text-slate-800">{label}</p>
                                                                    {payload.map((entry, index) => (
                                                                        <div key={"statsData-"+index} className="mb-2">
                                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                                <div className="w-3 rounded-full" style={{ backgroundColor: entry.color }}></div>
                                                                                <p className="text-sm font-medium" style={{ color: entry.color }}>
                                                                                    {entry.name}: <span className="font-bold">{entry.value}</span>
                                                                                </p>
                                                                            </div>
                                                                            <p className="text-sm fw-bold ml-5" style={{ color: entry.color }}>
                                                                                💰 {entry.dataKey === 'concluded'
                                                                                    ? `${(entry.payload.concludedValue || 0).toLocaleString('sl-SI')} €`
                                                                                    : `${(entry.payload.terminatedValue || 0).toLocaleString('sl-SI')} €`
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                    <div className="mt-3 pt-2 border-top border-slate-200">
                                                                        <p className="small text-muted d-flex align-items-center gap-1">
                                                                            <span>💡</span> Klikni za podrobnosti
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    }}
                                                />
                                                <Legend />
                                                <Bar dataKey="concluded" fill="#10b981" name="Sklenjene pogodbe" cursor="pointer" />
                                                <Bar dataKey="terminated" fill="#ef4444" name="Prekinjene pogodbe" cursor="pointer" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </CardBody>
                                </Card>

                                {/* Graf letnega fiksnega prihodka */}
                                <Card className="shadow-lg">
                                    <CardHeader className={"revenue-header p-4"}>
                                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
                                            <CardTitle className="d-flex align-items-center gap-2 mb-0">
                                                <div className="revenue-icon-wrapper">
                                                    <Euro size={20} color="#fff" />
                                                </div>
                                                Letni fiksni prihodek
                                                <Badge className="revenue-badge">Vključuje prihodnje</Badge>
                                            </CardTitle>
                                            <div className="d-flex gap-2">
                                                {revenueViewMode === "months" ? (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        onClick={() => setRevenueViewMode("months")}
                                                    >
                                                        Po mesecih
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        outline
                                                        onClick={() => setRevenueViewMode("months")}
                                                    >
                                                        Po mesecih
                                                    </Button>
                                                )}
                                                {revenueViewMode === "years" ? (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        onClick={() => setRevenueViewMode("years")}
                                                    >
                                                        Po letih
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        size="sm"
                                                        color="secondary"
                                                        outline
                                                        onClick={() => setRevenueViewMode("years")}
                                                    >
                                                        Po letih
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <ResponsiveContainer width="100%" height={350}>
                                            <BarChart data={revenueTimeSeriesData}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey={revenueViewMode === "months" ? "month" : "year"} />
                                            <YAxis />
                                            <Tooltip formatter={(value) => `${value.toLocaleString('sl-SI')} €`} />
                                            <Legend />
                                            <Bar dataKey="monthlyFixed" fill="#3b82f6" name="Pavšal" />
                                            <Bar dataKey="perInspection" fill="#10b981" name="Po pregledu" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </CardBody>
                                </Card>

                                {/* Pogodbe, ki potečejo */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle className="d-flex align-items-center gap-2">
                                    <Calendar className="w-5 h-5" />
                                    Pogodbe, ki potečejo v prihodnjih letih
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className="grid md:grid-cols-3 gap-4">
                                    <div className="p-4 bg-blue-50 rounded border border-blue-200">
                                        <p className="text-sm text-primary mb-2">Potečejo v 2026</p>
                                        <p className="text-2xl fw-bold text-primary mb-1">15 pogodb</p>
                                        <p className="text-lg fw-semibold text-blue-800">185,400 €</p>
                                    </div>
                                    <div className="p-4 bg-purple-50 rounded border border-purple-200">
                                        <p className="text-sm text-primary mb-2">Potečejo v 2027</p>
                                        <p className="text-2xl fw-bold text-primary mb-1">22 pogodb</p>
                                        <p className="text-lg fw-semibold text-purple-800">268,900 €</p>
                                    </div>
                                    <div className="p-4 bg-indigo-50 rounded border border-indigo-200">
                                        <p className="text-sm text-indigo-600 mb-2">Potečejo v 2028</p>
                                        <p className="text-2xl fw-bold text-primary mb-1">18 pogodb</p>
                                        <p className="text-lg fw-semibold text-indigo-800">224,600 €</p>
                                    </div>
                                    </div>
                                </CardBody>
                                </Card> */}

                                {/* Razdelitev pogodb po kategoriji objekta */}
                                <div className="row">
                                    <Col md="6">
                                        <Card>
                                            <CardHeader>
                                                <CardTitle>Razdelitev po kategoriji objekta</CardTitle>
                                            </CardHeader>
                                            <CardBody>
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>Kategorija</th>
                                                            <th className="text-center">Število</th>
                                                            <th className="text-right">Vrednost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {statsGroups.map((group) => (
                                                            <tr key={group.id}>
                                                                <td>{group.category_name}</td>
                                                                <td className="text-center"><Badge>{group.contracts_count}</Badge></td>
                                                                <td className="text-right font-semibold">{number_format(group.total_value, 2, ',', '.')} €</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md="6">
                                        <Card>
                                            <CardHeader>
                                                <CardTitle>Razdelitev po vrednosti pogodbe</CardTitle>
                                            </CardHeader>
                                            <CardBody>
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>Vrednostni razred</th>
                                                            <th className="text-center">Število</th>
                                                            <th className="text-right">Skupna vrednost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {statsValue.map((value) => (
                                                            <tr key={value.id}>
                                                                <td>{value.category_name}</td>
                                                                <td className="text-center"><Badge color="secondary">{value.contracts_count}</Badge></td>
                                                                <td className="text-right">{number_format(value.total_value, 2, ',', '.')} €</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </div>

                                {/* Finančni vidik - Spremljanje budžeta */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle className="d-flex align-items-center gap-2">
                                    <Euro className="w-5 h-5" />
                                    Spremljanje letnega budžeta po pogodbi
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className="space-y-4">
                                    {[
                                        { name: 'ABC d.o.o.', budget: 20000, used: 14500, remaining: 5500 },
                                        { name: 'XYZ d.d.', budget: 15000, used: 12800, remaining: 2200 },
                                        { name: 'DEF s.p.', budget: 25000, used: 18200, remaining: 6800 },
                                        { name: 'GHI d.o.o.', budget: 12000, used: 11400, remaining: 600 },
                                    ].map((contract, i) => {
                                        const percentage = (contract.used / contract.budget) * 100;
                                        return (
                                        <div key={i} className="p-4 border rounded-lg">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div>
                                                <p className="fw-semibold">{contract.name}</p>
                                                <p className="small text-muted">Budget: {contract.budget.toLocaleString('sl-SI')} €</p>
                                            </div>
                                            <Badge color={percentage > 90 ? "danger" : percentage > 70 ? "primary" : "secondary"}>
                                                {percentage.toFixed(0)}%
                                            </Badge>
                                            </div>
                                            <div className="w-full rounded-circle mb-2">
                                            <div
                                                className={`h-3 rounded-circle ${percentage > 90 ? 'bg-danger' : percentage > 70 ? 'bg-warning' : 'bg-success'}`}
                                                style={{ width: `${percentage}%` }}
                                            />
                                            </div>
                                            <div className="d-flex justify-content-between text-sm">
                                            <span className="text-red-600">Porabljeno: {contract.used.toLocaleString('sl-SI')} €</span>
                                            <span className="text-green-600">Na voljo: {contract.remaining.toLocaleString('sl-SI')} €</span>
                                            </div>
                                        </div>
                                        );
                                    })}
                                    </div>
                                </CardBody>
                                </Card> */}

                                {/* Izčrpanost budžeta po mesecih */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle>Mesečna izčrpanost budžeta</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <ResponsiveContainer width="100%" height={300}>
                                    <BarChart data={[
                                        { month: 'Jan', amount: 8200 },
                                        { month: 'Feb', amount: 9100 },
                                        { month: 'Mar', amount: 12400 },
                                        { month: 'Apr', amount: 11800 },
                                        { month: 'Maj', amount: 15600 },
                                        { month: 'Jun', amount: 13200 },
                                        { month: 'Jul', amount: 10500 },
                                        { month: 'Avg', amount: 9800 },
                                        { month: 'Sep', amount: 14200 },
                                        { month: 'Okt', amount: 16400 },
                                        { month: 'Nov', amount: 15100 },
                                        { month: 'Dec', amount: 11900 },
                                    ]}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis />
                                        <Tooltip formatter={(value) => `${value.toLocaleString('sl-SI')} €`} />
                                        <Bar dataKey="amount" fill="#3b82f6" />
                                    </BarChart>
                                    </ResponsiveContainer>
                                </CardBody>
                                </Card> */}

                                {/* Napoved prihodkov */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle className="d-flex align-items-center gap-2">
                                    <TrendingUp className="w-5 h-5" />
                                    Napoved fiksnih prihodkov (2026-2028)
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className="grid md:grid-cols-3 gap-4 mb-6">
                                    <div className="p-4 bg-green-50 rounded-lg">
                                        <p className="text-sm text-success mb-1">2026</p>
                                        <p className="text-2xl fw-bold text-success">412,800 €</p>
                                        <p className="small text-success mt-1">34,400 € / mesec</p>
                                    </div>
                                    <div className="p-4 bg-emerald-50 rounded-lg">
                                        <p className="text-sm text-emerald-600 mb-1">2027</p>
                                        <p className="text-2xl fw-bold text-emerald-700">389,200 €</p>
                                        <p className="small text-emerald-600 mt-1">32,433 € / mesec</p>
                                    </div>
                                    <div className="p-4 bg-teal-50 rounded-lg">
                                        <p className="text-sm text-teal-600 mb-1">2028</p>
                                        <p className="text-2xl fw-bold text-teal-700">356,600 €</p>
                                        <p className="small text-teal-600 mt-1">29,717 € / mesec</p>
                                    </div>
                                    </div>
                                    <ResponsiveContainer width="100%" height={250}>
                                    <LineChart data={[
                                        { month: 'Jan 26', value: 34200 },
                                        { month: 'Feb 26', value: 34400 },
                                        { month: 'Mar 26', value: 34600 },
                                        { month: 'Apr 26', value: 34100 },
                                        { month: 'Maj 26', value: 35200 },
                                        { month: 'Jun 26', value: 34800 },
                                        { month: 'Jul 26', value: 33900 },
                                        { month: 'Avg 26', value: 33200 },
                                        { month: 'Sep 26', value: 32800 },
                                        { month: 'Okt 26', value: 32400 },
                                        { month: 'Nov 26', value: 31900 },
                                        { month: 'Dec 26', value: 31600 },
                                    ]}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis />
                                        <Tooltip formatter={(value) => `${value.toLocaleString('sl-SI')} €`} />
                                        <Line type="monotone" dataKey="value" stroke="#10b981" strokeWidth={2} />
                                    </LineChart>
                                    </ResponsiveContainer>
                                </CardBody>
                                </Card> */}

                                {/* Pregledi po pogodbi */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle>Pregledi po pogodbi</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className="grid gap-4 mb-6">
                                    <div className="p-4 bg-blue-50 rounded border border-blue-200">
                                        <p className="text-sm text-primary mb-2">Izvedeni pregledi (letno)</p>
                                        <p className="text-3xl fw-bold text-primary mb-1">142 pregledov</p>
                                        <p className="text-lg fw-semibold text-blue-800">68,200 €</p>
                                    </div>
                                    <div className="p-4 bg-orange-50 rounded border border-orange-200">
                                        <p className="text-sm text-warning mb-2">Neizvedeni pregledi</p>
                                        <p className="text-3xl fw-bold text-warning mb-1">28 pregledov</p>
                                        <p className="text-lg fw-semibold text-orange-800">13,400 €</p>
                                    </div>
                                    </div>
                                    <Table>
                                    <thead>
                                        <tr>
                                        <th>Pogodba</th>
                                        <th className="text-center">Načrtovano</th>
                                        <th className="text-center">Izvedeno</th>
                                        <th className="text-center">Ostalo</th>
                                        <th className="text-right">Vrednost izvedenih</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td className="font-medium">ABC d.o.o.</td>
                                        <td className="text-center">24</td>
                                        <td className="text-center"><Badge className="bg-success">22</Badge></td>
                                        <td className="text-center"><Badge color="secondary">2</Badge></td>
                                        <td className="text-right font-semibold">10,560 €</td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">XYZ d.d.</td>
                                        <td className="text-center">36</td>
                                        <td className="text-center"><Badge className="bg-success">32</Badge></td>
                                        <td className="text-center"><Badge color="secondary">4</Badge></td>
                                        <td className="text-right font-semibold">15,360 €</td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">DEF s.p.</td>
                                        <td className="text-center">12</td>
                                        <td className="text-center"><Badge className="bg-success">12</Badge></td>
                                        <td className="text-center"><Badge color="secondary">0</Badge></td>
                                        <td className="text-right font-semibold">5,760 €</td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">GHI d.o.o.</td>
                                        <td className="text-center">48</td>
                                        <td className="text-center"><Badge className="bg-success">36</Badge></td>
                                        <td className="text-center"><Badge color="secondary">12</Badge></td>
                                        <td className="text-right font-semibold">17,280 €</td>
                                        </tr>
                                    </tbody>
                                    </Table>
                                </CardBody>
                                </Card> */}

                                {/* Način obračunavanja */}
                                {/* <div className="grid lg:grid-cols-2 gap-6">
                                <Card>
                                    <CardHeader>
                                    <CardTitle>Način obračunavanja</CardTitle>
                                    </CardHeader>
                                    <CardBody>
                                    <ResponsiveContainer width="100%" height={250}>
                                        <PieChart>
                                        <Pie
                                            data={[
                                            { name: 'Po rednem pregledu', value: 35 },
                                            { name: 'Pavšal', value: 18 },
                                            { name: 'Po uri', value: 10 },
                                            ]}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                            outerRadius={80}
                                            fill="#8884d8"
                                            dataKey="value"
                                        >
                                            <Cell fill="#3b82f6" />
                                            <Cell fill="#8b5cf6" />
                                            <Cell fill="#ec4899" />
                                        </Pie>
                                        <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>
                                    </CardBody>
                                </Card>

                                <Card>
                                    <CardHeader>
                                    <CardTitle>Prihodki po načinu obračunavanja</CardTitle>
                                    </CardHeader>
                                    <CardBody>
                                    <div className="space-y-4">
                                        <div className="p-4 bg-blue-50 rounded-lg">
                                        <div className="d-flex justify-content-between items-center">
                                            <div>
                                            <p className="text-sm text-blue-600">Po rednem pregledu</p>
                                            <p className="text-2xl fw-bold text-primary">186,400 €</p>
                                            </div>
                                            <Badge className="bg-blue-600">35 pogodb</Badge>
                                        </div>
                                        </div>
                                        <div className="p-4 bg-purple-50 rounded-lg">
                                        <div className="d-flex justify-content-between items-center">
                                            <div>
                                            <p className="text-sm text-purple-600">Pavšal</p>
                                            <p className="text-2xl fw-bold text-purple-700">142,800 €</p>
                                            </div>
                                            <Badge className="bg-purple-600">18 pogodb</Badge>
                                        </div>
                                        </div>
                                        <div className="p-4 bg-pink-50 rounded-lg">
                                        <div className="d-flex justify-content-between items-center">
                                            <div>
                                            <p className="text-sm text-pink-600">Po uri</p>
                                            <p className="text-2xl fw-bold text-pink-700">82,800 €</p>
                                            </div>
                                            <Badge className="bg-pink-600">10 pogodb</Badge>
                                        </div>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </div> */}

                                {/* Analiza dobičkonosnosti */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle className="d-flex align-items-center gap-2">
                                    <TrendingUp className="w-5 h-5" />
                                    Analiza dobičkonosnosti po pogodbi
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Table>
                                    <thead>
                                        <tr>
                                        <th>Pogodba</th>
                                        <th>Kategorija</th>
                                        <th>Vrsta</th>
                                        <th className="text-right">Cena letno</th>
                                        <th className="text-right">Stroški</th>
                                        <th className="text-right">Dobiček</th>
                                        <th className="text-right">Marža</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td className="font-medium">ABC d.o.o.</td>
                                        <td><Badge className="bg-blue-100 text-primary">Poslovni</Badge></td>
                                        <td>Pavšal</td>
                                        <td className="text-right">20,000 €</td>
                                        <td className="text-right text-red-600">12,400 €</td>
                                        <td className="text-right fw-bold text-green-600">7,600 €</td>
                                        <td className="text-right"><Badge className="bg-success">38%</Badge></td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">XYZ d.d.</td>
                                        <td><Badge className="bg-purple-100 text-purple-700">Industrijski</Badge></td>
                                        <td>Po pregledu</td>
                                        <td className="text-right">28,600 €</td>
                                        <td className="text-right text-red-600">18,200 €</td>
                                        <td className="text-right fw-bold text-green-600">10,400 €</td>
                                        <td className="text-right"><Badge className="bg-success">36%</Badge></td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">DEF s.p.</td>
                                        <td><Badge className="bg-green-100 text-success">Stanovanjski</Badge></td>
                                        <td>Po uri</td>
                                        <td className="text-right">8,400 €</td>
                                        <td className="text-right text-red-600">4,600 €</td>
                                        <td className="text-right fw-bold text-green-600">3,800 €</td>
                                        <td className="text-right"><Badge className="bg-success">45%</Badge></td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">GHI d.o.o.</td>
                                        <td><Badge className="bg-amber-100 text-amber-700">Javni</Badge></td>
                                        <td>Po pregledu</td>
                                        <td className="text-right">32,400 €</td>
                                        <td className="text-right text-red-600">24,800 €</td>
                                        <td className="text-right fw-bold text-green-600">7,600 €</td>
                                        <td className="text-right"><Badge className="bg-orange-600">23%</Badge></td>
                                        </tr>
                                        <tr>
                                        <td className="font-medium">JKL d.o.o.</td>
                                        <td><Badge className="bg-blue-100 text-primary">Poslovni</Badge></td>
                                        <td>Pavšal</td>
                                        <td className="text-right">18,200 €</td>
                                        <td className="text-right text-red-600">10,800 €</td>
                                        <td className="text-right fw-bold text-green-600">7,400 €</td>
                                        <td className="text-right"><Badge className="bg-success">41%</Badge></td>
                                        </tr>
                                    </tbody>
                                    </Table>
                                </CardBody>
                                </Card> */}

                                {/* Povprečna dobičkonosnost po kategoriji */}
                                {/* <Card>
                                <CardHeader>
                                    <CardTitle>Povprečna dobičkonosnost po kategoriji pogodbe</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <ResponsiveContainer width="100%" height={300}>
                                    <BarChart data={[
                                        { category: 'Stanovanjski', margin: 42 },
                                        { category: 'Poslovni', margin: 38 },
                                        { category: 'Industrijski', margin: 34 },
                                        { category: 'Javni', margin: 26 },
                                    ]}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="category" />
                                        <YAxis />
                                        <Tooltip formatter={(value) => `${value}%`} />
                                        <Bar dataKey="margin" fill="#10b981" />
                                    </BarChart>
                                    </ResponsiveContainer>
                                </CardBody>
                                </Card> */}

                            </TabPane>
                        </TabContent>

                        {/* Dialog za prikaz garancijskih nalogov po sistemih */}
                        {/* <Modal isOpen={isWarrantyDialogOpen} toggle={() => setIsWarrantyDialogOpen(false)} size="lg">
                            <ModalHeader toggle={() => setIsWarrantyDialogOpen(false)}>
                                Garancijski nalogi - {selectedWarrantySystem}
                            </ModalHeader>
                            <ModalBody className="overflow-auto" style={{maxHeight: '70vh'}}>
                                <div className="space-y-4">
                                    {warrantyTasksBySystem[selectedWarrantySystem] && warrantyTasksBySystem[selectedWarrantySystem].length > 0 ? (
                                        <>
                                            <div className="p-4 bg-blue-50 rounded border border-blue-200">
                                                <p className="text-sm text-primary mb-1">Skupaj nalogov za {selectedWarrantySystem}</p>
                                                <p className="text-2xl fw-bold text-primary">{warrantyTasksBySystem[selectedWarrantySystem].length}</p>
                                            </div>
                                            <Table>
                                                <thead>
                                                <tr>
                                                    <th>Objekt</th>
                                                    <th>Datum</th>
                                                    <th>Številka naloga</th>
                                                    <th className="text-right">Storitve</th>
                                                    <th className="text-right">Material</th>
                                                    <th className="text-right">Skupaj</th>
                                                    <th className="text-center">Arhiv</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {warrantyTasksBySystem[selectedWarrantySystem].map((task, idx) => (
                                                    <tr key={idx}>
                                                    <td className="font-medium">{task.object}</td>
                                                    <td>{task.date}</td>
                                                    <td>
                                                        <Badge color="secondary" className="font-mono">{task.workOrderId}</Badge>
                                                    </td>
                                                    <td className="text-right text-warning">{task.service.toLocaleString('sl-SI')} €</td>
                                                    <td className="text-right text-danger">{task.material.toLocaleString('sl-SI')} €</td>
                                                    <td className="text-right font-weight-bold">{(task.service + task.material).toLocaleString('sl-SI')} €</td>
                                                    <td className="text-center">
                                                        <Button color="link" size="sm" >
                                                        Odpri
                                                        </Button>
                                                    </td>
                                                    </tr>
                                                ))}
                                                <tr className="font-weight-bold">
                                                    <td colSpan={3}>Skupaj:</td>
                                                    <td className="text-right text-warning">
                                                    {warrantyTasksBySystem[selectedWarrantySystem].reduce((sum, t) => sum + t.service, 0).toLocaleString('sl-SI')} €
                                                    </td>
                                                    <td className="text-right text-danger">
                                                    {warrantyTasksBySystem[selectedWarrantySystem].reduce((sum, t) => sum + t.material, 0).toLocaleString('sl-SI')} €
                                                    </td>
                                                    <td className="text-right">
                                                    {warrantyTasksBySystem[selectedWarrantySystem].reduce((sum, t) => sum + t.service + t.material, 0).toLocaleString('sl-SI')} €
                                                    </td>
                                                    <td></td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </>
                                    ) : (
                                        <div className="text-center py-8 text-muted">
                                        <p>Ni podatkov za izbrani sistem.</p>
                                        </div>
                                    )}
                                </div>
                            </ModalBody>
                        </Modal> */}

                        {/* Dialog za prikaz pogodb */}
                        <Modal isOpen={contractsModalOpen} toggle={() => setContractsModalOpen(false)} size="xl" className="analytics-modal">
                            <ModalHeader toggle={() => setContractsModalOpen(false)} className={"border-bottom-0"}>
                                Pogodbe - {selectedPeriodContracts?.period}
                            </ModalHeader>
                            <ModalBody className="overflow-auto" style={{maxHeight: '70vh'}}>
                                {!isNull(selectedPeriodContracts) &&
                                    <div>
                                        {/* Sklenjene pogodbe */}
                                        {selectedPeriodContracts.signed?.rows?.length > 0 && (
                                            <div className="mb-4">
                                                <h3 className="modal-signed-title">
                                                    <CheckCircle2 size="20" color="#15803d" />
                                                    Sklenjene pogodbe ({selectedPeriodContracts.signed.count})
                                                </h3>
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>Naročnik</th>
                                                            <th>Sistem</th>
                                                            <th>Datum</th>
                                                            <th className="text-end">Vrednost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedPeriodContracts.signed.rows.map((contract, idx) => (
                                                            <tr key={"signed-"+idx}>
                                                                <td className="font-normal">{contract.client}</td>
                                                                <td><Badge className="modal-badge">{contract.system}</Badge></td>
                                                                <td>{moment(contract.date).format('DD.MM.YYYY')}</td>
                                                                <td className="text-end font-weight-bold text-success">
                                                                    {number_format(contract.price, 2, ',', '.')} €
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr className="modal-signed-total">
                                                            <td colSpan={3}>Skupaj:</td>
                                                            <td className="text-end text-success">
                                                                {selectedPeriodContracts.signed.total.toLocaleString('sl-SI')} €
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}

                                        {/* Prekinjene pogodbe */}
                                        {selectedPeriodContracts.expired?.rows?.length > 0 && (
                                            <div>
                                                <h3 className="modal-expired-title">
                                                    <Clock size="20" color="#b91c1c" />
                                                    Prekinjene pogodbe ({selectedPeriodContracts.expired.count})
                                                </h3>
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>Naročnik</th>
                                                            <th>Sistem</th>
                                                            <th>Datum prekinitve</th>
                                                            <th className="text-end">Vrednost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedPeriodContracts.expired.rows.map((contract, idx) => (
                                                            <tr key={"expired-"+idx}>
                                                                <td className="font-medium">{contract.client}</td>
                                                                <td><Badge className="modal-badge">{contract.system}</Badge></td>
                                                                <td>{moment(contract.date).format('DD.MM.YYYY')}</td>
                                                                <td className="text-end font-weight-bold text-danger">
                                                                    {number_format(contract.price, 2, ',', '.')} €
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr className="modal-expired-total">
                                                            <td colSpan={3}>Skupaj:</td>
                                                            <td className="text-end text-danger">
                                                                {selectedPeriodContracts.expired.total.toLocaleString('sl-SI')} €
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}

                                        {selectedPeriodContracts.signed?.rows?.length === 0 && selectedPeriodContracts.expired?.rows?.length === 0 && (
                                            <div className="text-center py-8 text-muted">
                                                <p>Ni podatkov o pogodbah za izbrano obdobje.</p>
                                            </div>
                                        )}
                                    </div>
                                }
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </Container>
        </>
    );
}


































